import { Injectable } from '@angular/core';
import { AuthenticationResult } from '@azure/msal-browser';

@Injectable({
    providedIn: 'root',
})
export class TenantClaimResolverService {
    private readonly tenantClaimKeys: readonly string[] = ['tenantSlug', 'tenant_slug', 'tenant'];

    public resolveTenantFromAuthResult(authenticationResult: AuthenticationResult): string | undefined {
        const primaryClaims = authenticationResult.account?.idTokenClaims as Record<string, unknown> | undefined;
        const fallbackClaims = authenticationResult.idTokenClaims as Record<string, unknown> | undefined;

        const tenantFromPrimaryClaims = this.resolveTenantFromClaims(primaryClaims);
        if (tenantFromPrimaryClaims) {
            return tenantFromPrimaryClaims;
        }

        return this.resolveTenantFromClaims(fallbackClaims);
    }

    public resolveTenantFromClaims(claims?: Record<string, unknown>): string | undefined {
        if (!claims) {
            return undefined;
        }

        for (const claimKey of this.tenantClaimKeys) {
            const direct = this.resolveStringClaim(claims, claimKey);
            if (direct) {
                return direct;
            }
        }

        return undefined;
    }

    public resolveStringClaim(claims: Record<string, unknown>, claimKey: string): string | undefined {
        const directValue = claims[claimKey];
        if (typeof directValue === 'string' && directValue.trim().length > 0) {
            return directValue.trim();
        }

        const normalizedClaimKey = claimKey.toLowerCase();

        for (const [key, value] of Object.entries(claims)) {
            if (typeof value !== 'string') {
                continue;
            }

            const normalizedKey = key.toLowerCase();
            const matchesCustomClaimSuffix = normalizedKey.endsWith(`_${normalizedClaimKey}`) || normalizedKey.endsWith(`/${normalizedClaimKey}`);
            if (!matchesCustomClaimSuffix) {
                continue;
            }

            const trimmedValue = value.trim();
            if (trimmedValue.length > 0) {
                return trimmedValue;
            }
        }

        return undefined;
    }
}